import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import defult from './defult.jpg';
import { useStateContext } from '../../Contexts/ContextProvider';
import Loader from '../../assets/tools/Loder/loader';
import ConferenceDropdown from '../../Forms/ConferenceDropdown';

const EditNews = () => {
  const { id } = useParams();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [active, setActive] = useState(1);
  const [penn, setPenn] = useState(0);
  const { API } = useStateContext();
  const [conferenceId , setConferenceId ] = useState (0); 
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await AxiosClient.get(`/news/${id}`);
        const newsData = response.data;
        console.log(newsData) ; 
        setTitle(newsData.title);
        setConferenceId(newsData.conference_id);
        setDescription(newsData.description);
        setContent(newsData.content);
        setActive(newsData.active);
        setPenn(newsData.penn);
        setImagePreviewUrl(`${API}${newsData.image}`);
      } catch (error) {
        console.error('Error fetching news:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [id, API]);

  const handleImageChange = (e) => {
    setIsImageUploaded(true);
    const selectedImage = e.target.files[0];

    const reader = new FileReader();
    reader.onload = (event) => {
      setImagePreviewUrl(event.target.result);
    };
    reader.readAsDataURL(selectedImage);
  };

  const handleCancel = () => {
    navigate("/news");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      title,
      description,
      content,
      image: document.getElementById('image').files[0],
      penn, 
      conference_id: conferenceId,
      active,
    };

    try {
      await AxiosClient.put(`/news/${id}`, payload);
      alert('News updated successfully');
      navigate("/News");
    } catch (error) {
      console.error('Error updating news:', error);
    }
  };

  if (loading) {
    return <Loader label="Loading article details..." />;
  }

  return (
    <div className="m-4">
      <form className="form-group"> 
        <ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId}/>
        <h5>Title</h5>
        <div className="input-group input-group-outline mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Enter title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        <h5>Description</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea
            className="form-control"
            placeholder="Enter description"
            rows={5}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <h5>Image</h5>
        <div className="w-full flex flex-wrap items-center">
          <label htmlFor="image" className="w-full block mb-2 font-medium text-gray-700 m-2">
            Article Image:
          </label>
          <input
            type="file"
            id="image"
            accept="image/*"
            onChange={handleImageChange}
            className="py-2 m-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <img
          src={imagePreviewUrl ? imagePreviewUrl : defult}
          alt="Uploaded"
          style={{ maxWidth: '250px', maxHeight: '25%' }}
          className="w-full object-contain mb-w-100 text-center"
        />

        <hr className="border-gray-300 my-4" />

        <h5>Content</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea
            className="form-control"
            placeholder="Content"
            rows={15}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </div>

        <button onClick={handleSubmit} className="btn btn-success m-2">
          Save
        </button>
        <button onClick={handleCancel} className="btn btn-danger m-2">
          Cancel
        </button>
      </form>
    </div>
  );
};

export default EditNews;
